module.exports = __webpack_public_path__ + "mg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mg.svg
// module id = 940
// module chunks = 0